import React from "react";
import { MessageCircle } from "lucide-react";

const HomeFooter = () => {
    return (
        <>
            {/* Footer */}
            <footer className="bg-slate-900 py-16">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="flex items-center space-x-3 mb-8 md:mb-0">
                            <img
                                src="https://static.wixstatic.com/media/755cdc_fba32a57a6554eb9b4205d19bf8f419e~mv2.png/v1/fill/w_518,h_98,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo%20verde.png"
                                alt="MiguelMX"
                                className="h-8 w-auto object-contain filter brightness-0 invert"
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                }}
                            />
                            <div className="w-32 h-8 bg-gradient-to-r from-green-600 to-green-500 rounded-lg items-center justify-center shadow-lg hidden">
                                <span className="text-white font-bold text-lg">MiguelMX</span>
                            </div>
                        </div>
                        <div className="text-center md:text-right">
                            <p className="text-slate-400 mb-4 text-lg font-medium">
                                Asesoría financiera independiente, responsable y cercana
                            </p>
                            <div className="flex flex-col md:flex-row md:justify-end space-y-2 md:space-y-0 md:space-x-6">
                                <p className="text-slate-500 font-medium">© 2025 MiguelMX®</p>
                                <p className="text-[#14840c] font-medium">
                                    Hermosillo, Sonora, México
                                </p>
                                <button className="text-slate-400 hover:text-slate-300 font-medium transition-colors">
                                    Aviso de Privacidad
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            {/* WhatsApp Float Button */}
            <button className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-40">
                <MessageCircle className="w-7 h-7" />
            </button>
        </>
    );
};

export default HomeFooter;